import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import useMedia from 'src/hooks/useMedia'
import { minDesktopScreenWidth } from 'src/utils/breakpoints'
import { cybersec2026Banner } from 'src/assets/images'
import InfoBox from 'src/components/PostGraduationContent/PostgraduateComponents/InfoBox/InfoBox'
import Tabs from 'src/components/PostGraduationContent/PostGraduationDetails/Tabs/PostGraduationTabs'
import Tab from 'src/components/PostGraduationContent/PostGraduationDetails/Tabs/PostGraduationTab'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import Introduction from './Introduction'
import Information from './Information'
import Disciplines from './Disciplines'
import Selection from './Selection'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './PostGraduate2026Content.styles'

const PostGraduate2026Content = () => {
  const { t } = useTranslation()
  const { width } = useMedia()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  const boxes = [
    'Presencial',
    '496 h/aulas,</br> 31 créditos',
    'Período:</br> <strong>24 meses</strong>',
    'Aulas iniciam:</br> <strong>12/03/2026</strong>'
  ]

  return (
    <Box className={globalClasses.containerPages}>
      <BreadcrumbsComponent
        crumbs={[
          { label: t('navbar.start'), path: '/' },
          { label: t('navbar.postgraduate'), path: '/postgraduate' },
          { label: 'Residência em Segurança Cibernética 2026' }
        ]}
      />
      <Box className={classes.container}>
        <Typography className={globalClasses.titleSectionVariant2}>
          Residência em Segurança Cibernética 2026
        </Typography>
        <Box className={classes.contentWrapper}>
          <Box className={classes.header}>
            {width >= minDesktopScreenWidth ? (
              <InfoBox boxes={boxes} />
            ) : (
              <>
                <InfoBox boxes={boxes.slice(0, 2)} />
                <InfoBox boxes={boxes.slice(2)} />
              </>
            )}
            <img
              className={classes.promoImg}
              src={cybersec2026Banner}
              alt="Promo banner UFC Lenovo"
            />
          </Box>
          <Tabs>
            <Tab title="Apresentação">
              <Introduction />
            </Tab>
            <Tab title="Formato">
              <Information />
            </Tab>
            <Tab title="Disciplinas">
              <Disciplines />
            </Tab>
            <Tab title="Seleção">
              <Selection />
            </Tab>
          </Tabs>
        </Box>
      </Box>
    </Box>
  )
}

export default PostGraduate2026Content
